/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserDashboardResponseDto } from '../../models/backend-user-dashboard-response-dto';
import { BackendUserDashboardUpdateDto } from '../../models/backend-user-dashboard-update-dto';

export interface UpdateDashboardMeDashboardsDashboardIdPatch$Params {
  dashboard_id: string;
  body: BackendUserDashboardUpdateDto;
}

export function updateDashboardMeDashboardsDashboardIdPatch(
  http: HttpClient,
  rootUrl: string,
  params: UpdateDashboardMeDashboardsDashboardIdPatch$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserDashboardResponseDto>> {
  const rb = new RequestBuilder(rootUrl, updateDashboardMeDashboardsDashboardIdPatch.PATH, 'patch');
  if (params) {
    rb.path('dashboard_id', params.dashboard_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserDashboardResponseDto>;
    }),
  );
}

updateDashboardMeDashboardsDashboardIdPatch.PATH = '/me/dashboards/{dashboard_id}';
